import { Tabs } from "antd";
import React, { useEffect } from "react";

export const items = [
  {
    label: `Terms & Conditions`,
    key: "1",
    children: (
      <div className="policy_section grievance_policy terms">
        {/* <b></b>
        <h3 className="policy_header">Terms & Conditions</h3> */}
        <h3>Nature of Business</h3>
        <span className="span_section mt1">
          Providing Expense Management Solution for Corporates and there is also
          a provision to opt for the multi- wallet Prepaid Expense Card for
          various payments on Ecom, POS, ATM and Transit. The Prepaid Expense
          Card offered to the Corporate Employees is a multi-wallet card which
          can be used across different digital payment channels as well as for
          Urban Mobility like Metro Rails and can also work as a Tax Benefit
          solution with its Meal and Fuel wallet options. To summarize it is a
          All in One Card which can be used at multiple merchant locations, can
          be used as a tax benefit solution and can also be used for travel by
          the Metros or Buses
        </span>

        <h3>Terms & Conditions:</h3>
        <p>
          <span className="span_section mt1">
            These terms and conditions (“<b>Terms and Conditions</b>”) apply to
            and regulate the provisions of loading or re-loading or topping-up
            of prepaid payment instrument namely ‘
            <span style={{ textDecoration: "underline", color: "#000" }}>
              Prepaid Expense Card
            </span>
            ’ (“
            <b>Cards</b>”) by ‘<b>PayCraft Solution Private Limited</b>’ having
            its registered office at B-1103, 1104 Kailas Business Park, Kailas
            Complex, Ghatkopar- Powai Link Road, Park site, Vikhroli, Mumbai
            400079, India (“<b>Company</b>”, or “<b>we</b>,” or “<b>Us</b>”) at
            &nbsp;
            <a
              href="https://nsdlbank.com/prepaid_card.php"
              target="_blank"
              style={{ textDecoration: "underline" }}
            >
              https://nsdlbank.com/prepaid_card.php
            </a>
            &nbsp; or mobile application of the Company (“<b>Platform</b>”).
          </span>
          <span className="span_section mt1">
            The Prepaid Expense Card is a multi-wallet card issued by the Issuer
            (as defined hereinafter) that offers unmatched versatility, allowing
            seamless transactions across ATMs, e-commerce platforms, PoS
            machines, and urban mobility like metro rails. The Users may avail
            its wide acceptance at various merchant locations and utilize it for
            tax benefits, meal and fuel allowances, and convenient travel by
            metros or buses. It facilitates expense management, ensures budget
            control, and provides enhanced security designed to meet all the
            corporate needs of the Users.
          </span>
          <span className="span_section mt1">
            The loading or re-loading or topping-up of the Card at Platform is
            subject to the Terms and Conditions set out below. These Terms and
            Conditions are a legally binding contract between you and the
            Company to avail any services at the Platform. By completing the
            sign-up process for availing the services at the Platform, you are
            deemed to have expressly read, understood and accepted each and
            every Terms and Conditions mentioned herein. You agree to be bound
            by all the Terms and Conditions mentioned herein, as may be amended
            from time to time.
          </span>
        </p>
        <h3 className="mt2">
          I. <b className="ml1" style={{marginLeft:"1.4rem"}}>DEFINITIONS</b>
        </h3>
        <p>
          <span className="span_section">
            In these Terms and Conditions, unless the contrary intention appears
            (i) inclusion in quotations and/ or parenthesis have the meanings so
            ascribed; and (ii) the following terms shall have the meanings
            assigned to them herein below:
          </span>
        </p>
        <div className="flex-start mt1">
          <span className="span_section ml1">a.</span>
          <span className="span_section ml1">
            <b>“Applicable Law”</b> shall mean and include all applicable
            statutes, enactments or acts of any legislative body in India, law,
            ordinances, rules, bye-laws, regulations, notifications, guidelines,
            policies, directions, directives and orders of any governmental
            authority and any modifications or re-enactments thereof;
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">b.</span>
          <span className="span_section ml1">
            <b>“Business Day”</b> means a day other than a Sunday, 2nd or 4th
            Saturday as per Negotiable Instrument Act, 1881 on which banks are
            open to transact business of banking.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">c.</span>
          <span className="span_section ml1">
            <b>“Charges”</b> means such levy, costs, fees and charges levied by
            Us for usage of our services at the Platform, as amended from time
            to time.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">d.</span>
          <span className="span_section ml1">
            <b>“User”</b> or “you” shall mean any person to who wish to avail
            the services provided at the Platform including loading or
            re-loading or top-up of the Card.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">e.</span>
          <span className="span_section ml1">
            <b>“Payment Channel”</b> shall mean various modes of transactions
            including but not limited to EDC/POS terminals/kiosks/internet
            payment gateway/mobile based payment solutions and various other
            modes as intimated by Issuer and used by Payment Channel Service
            Provider from time to time.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1" style={{marginLeft:"1.2rem"}}>f.</span>
          <span className="span_section ml1">
            <b>“Payment Channel Service Provider”</b> shall mean and include the
            entities that have obtained payment aggregator and payment gateway
            license as per the RBI guidelines bearing number
            RBI/DPSS/2019-20/174 dated March 17, 2020 and whose Payment Channel
            services shall be used by the Company on the Platform to enable the
            Transaction through different Payment Channel such as Debit Cards,
            Net Banking, UPI etc.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">g.</span>
          <span className="span_section ml1">
            <b>“Source Account”</b> shall mean the bank account / payment card /
            other digital payment mode that the User may have specified for the
            purpose of funding the Transaction at the Platform. It is important
            to note that different Users may have different designated source
            accounts.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">h.</span>
          <span className="span_section ml1">
            <b>“Transaction”</b> means any transaction initiated by the User for
            loading or re-loading or topping-up of the Card at Platform.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">i.</span>
          <span className="span_section ml1">
            <b>“Issuer”</b> shall mean and include any a banking company under
            the Banking Regulations Act 1949 and who is licensed to carry on its
            business of banking including issuance of Card by the RBI.
          </span>
        </div>
        <h3 className="mt2">
          II. <b className="mt2 ml1"  >TOP-UP/LOADING AND RELOADING PROCESS</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">2.1.</span>
          <span className="span_section ml1">
            The Users can conveniently top-up, load, or re-load their Cards by
            providing the details of card and the desired recharge amount
            through our secure online Platform.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">2.2.</span>
          <span className="span_section ml1">
            The first-time User must create an account at our Platform
            <b>(“Account”)</b>. Pursuant to creating an Account, you may log-in
            to the Account and avail various services provided at the Platform.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">2.3.</span>
          <span className="span_section ml1" >
            The process for loading value onto the Cards shall be as follows:
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1" >a.</span>
          <span className="span_section ml1">
            To load or reload value on the Card, the User must log-in to the
            Account and provide details of card and value of desired amount to
            be loaded or reloaded to the Card at the Platform. The User has the
            option to utilize any Payment Channel for loading or reloading the
            Card. By submitting the Card and other relevant details on the
            Platform, the User acknowledges that it serves as an instruction and
            consent from the User to Us, authorizing the initiation of the
            Transaction.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">b.</span>
          <span className="span_section ml1">
            Upon receiving the User's instruction, our system will automatically
            initiate the Transaction and send a request to the Issuer for
            Transaction authentication.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">c.</span>
          <span className="span_section ml1">
            Once the Transaction is successfully authenticated by the Issuer and
            the Payment Channel Service Provider has processed the Transaction,
            the requested value will be loaded or reloaded onto your Card.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">2.4.</span>
          <span className="span_section ml1">
            Subject to the Terms and Conditions, once the Transaction/top-up,
            loading, or re-loading process is successfully completed, the Card
            balance will be updated instantly, enabling the User to use their
            funds for various transactions without delay. While we strive to
            provide a seamless and real- time top-up, loading, or re-loading
            process, it is important to note that in rare instances, technical
            issues or defaults at the Issuer's or Payment Channel Service
            Provider’s end may cause delays in updating the Card balance or
            failure in completing the Transaction. Such occurrences are beyond
            our immediate control, and we shall not be held responsible for any
            inconvenience or loss resulting from such technical issues or
            defaults of any person. Rest assured, we will make every effort to
            promptly resolve any issues that may arise and ensure a smooth
            experience for our valued Users. We advise the Users to reach out to
            our customer support team at <span className="email_style"> prepaid.service@nsdlbank.co.in </span> 
            in case of any concerns or discrepancies related to the Transaction.
          </span>
        </div>
        <h3 className="mt2">
          III. <b className="ml1 mt2" style={{marginLeft:"0.8rem"}}>TOP-UP/LOADING AND RELOADING PROCESS</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">3.1.</span>
          <span className="span_section ml1">
            The User agrees and acknowledges that loading or reloading value
            onto the Card is subject to permissible limits set by the Issuer or
            the RBI, which may be revised from time to time. The Company shall
            not be held liable for any failure to load or reload the Card with
            value exceeding the permissible limits. If the User initiates a
            Transaction for a value beyond the permissible limits, the Company
            will reject such Transaction and request the User to re-initiate the
            Transaction within the specified permissible limits.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">3.2.</span>
          <span className="span_section ml1">
            The User hereby undertakes and acknowledges that the following
            limits:
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">a.</span>
          <span className="span_section ml1" >
            The limit of INR 2,00,000/- shall be applicable for loading or
            reloading of full-KYC Prepaid Payment Instrument (PPI) (
            <i>as defined in the RBI Master Directors</i>). The limit shall be
            calculated after combining the value in all full-KYC PPIs issued to
            you by a PPI Issuer under various arrangements/forms of PPI.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">b.</span>
          <span className="span_section ml1">
            In case a PPI Issuer has issued multiple PPIs to you due to any
            reasons (e.g. multiple co- branding partners, issuance of PPI in
            different form factors like wallets/cards), then we will monitor the
            limits through a centralized database/management information system
            (MIS) as required under the RBI’s Master Directions on Prepaid
            Payment Instruments (PPIs) available at &nbsp;
            <a
              href="https://www.rbi.org.in/Scripts/BS_ViewMasDirections.aspx?id=12156."
              style={{ color: "blue", textDecoration: "underline" }}
            >
              https://www.rbi.org.in/Scripts/BS_ViewMasDirections.aspx?id=12156.
            </a>
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">c.</span>
          <span className="span_section ml1">
            Similarly, the limit of INR 10,000 shall be applicable for loading
            or reloading any small PPIs (
            <i>as defined in the RBI Master Directors</i>) from time to time
            issued by the PPI Issuer under various arrangements/forms of PPI.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">3.3.</span>
          <span className="span_section ml1">
            The permissible limits may be revised from time to time due to
            legal, risk management, regulatory compliance requirements from RBI
            or Banks, security considerations, or other purposes, in accordance
            with the Applicable Law.
          </span>
        </div>
        <h3 className="mt2">
          IV. <b className="mt2 ml1" style={{marginLeft:"0.7rem"}} >CANCELLATION</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">4.1.</span>
          <span className="span_section ml1">
            The User may request the cancellation of their top-up, loading, or
            reloading request by reaching out to our customer support team at
            <span className="email_style"> prepaid.service@nsdlbank.co.in </span> within a specified
            timeframe. The request for cancellation must be made before the
            Transaction is successfully processed.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">4.2.</span>
          <span className="span_section ml1">
            The User must provide valid transaction and identification details
            for processing of cancellation request.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">4.3.</span>
          <span className="span_section ml1">
            In the event of a transaction failure, an instant refund will be
            processed to your designated Source Account, provided the
            Transaction was made using a credit card or debit card at our
            Platform.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">4.4.</span>
          <span className="span_section ml1">
            If the top-up, loading, or reloading process has already been
            initiated and the Transaction is in progress, the cancellation
            request shall not be entertained. In such cases, the funds will be
            credited to the Card balance as per the successful Transaction.
          </span>
        </div>
        <h3 className="mt2">
          V. <b className="ml1 mt2">REFUND</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">5.1.</span>
          <span className="span_section ml1">
            In the event of a successful cancellation request, the refund amount
            will be credited to the Source Account used for the top-up, loading,
            or reloading transaction.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">5.2.</span>
          <span className="span_section ml1">
            If you encounter a situation where you have made a payment but have
            not received the top-up on your Card, kindly reach out to Us at
            <span className="email_style"> prepaid.service@nsdlbank.co.in </span> with your order number or
            call Us at our customer care-number <b>[022-42022190]</b>. We will
            make every effort to resolve the issue as quickly as possible.
            Please note that no refund shall be issued for the successful
            Transaction.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">5.3.</span>
          <span className="span_section ml1">
            Once you inform Us with the order number, we will promptly initiate
            your refund request with the Payment Channel Service Provider. The
            refund will be processed within a reasonable timeframe, typically
            within 3-7 Business Days from the date of the request. In case of
            technical issues or delays caused by third-party payment gateways or
            Issuer or banks, the refund processing time may vary, and we shall
            not be liable for any such delays beyond our control.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">5.4.</span>
          <span className="span_section ml1">
            The refunded amount will be equal to the original Transaction
            amount, excluding any applicable transaction fees or charges.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">5.5.</span>
          <span className="span_section ml1">
            If you have any further queries or concerns, please feel free to
            contact Us at care <span className="email_style"> prepaid.service@nsdlbank.co.in </span> with your
            order number or call our customer care number <b>[022-42022190]</b>.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">5.6.</span>
          <span className="span_section ml1">
            Non-Refundable Scenarios: Once a Transaction is successfully
            processed, the amount loaded onto the Card becomes non-refundable.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">5.7.</span>
          <span className="span_section ml1">Exceptions</span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">a.</span>
          <span className="span_section ml1">
            In the case of proven fraudulent or unauthorized transactions, we
            reserve the right to investigate and refund the amount to the
            affected the User as per the Applicable Laws and regulations.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">b.</span>
          <span className="span_section ml1">
            Refunds for any Transactions conducted in violation of our Terms and
            Conditions or any fraudulent activities will not be processed, and
            appropriate legal actions shall be taken.
          </span>
        </div>
        <h3 className="mt2">
          VI. <b className="ml1 mt1" style={{marginLeft:"0.7rem"}}>PRICING</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">6.1.</span>
          <span className="span_section ml1">
            A nominal Charge shall be applicable for each top-up, loading, or
            re-loading Transaction. The User shall pay <i>inter alia</i>
            following Charges:
          </span>
        </div>
        <table className="ml4 mt1" style={{ width: "80%" }}>
          <thead>
            <tr>
              <th>SR.NO</th>
              <th>FEE TYPE</th>
              <th>FEE (INR)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Replacement Fee</td>
              <td>199</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Dormancy Fee</td>
              <td>0</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Annual Fee</td>
              <td>0</td>
            </tr>
            <tr>
              <td>4</td>
              <td>ATM Withdrawal Fee</td>
              <td>25</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Balance Enquiry Fee from ATM</td>
              <td>10</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Balance Enquiry Fee from Mobile App</td>
              <td>0</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Mini Statement Fee from ATM</td>
              <td>10</td>
            </tr>
            <tr>
              <td>8</td>
              <td>Mini Statement Fee from Mobile App</td>
              <td>0</td>
            </tr>
            <tr>
              <td>9</td>
              <td>PIN Change Fee at ATM</td>
              <td>10</td>
            </tr>
            <tr>
              <td>10</td>
              <td>Imps Fee</td>
              <td >10</td>
            </tr>
            <tr>
              <td>11</td>
              <td>Payment Gateway Top Up Services</td>
              <td>0</td>
            </tr>
          </tbody>
        </table>
        <div className="flex-start mt1">
          <span className="span_section">6.2.</span>
          <span className="span_section ml1">
            It is clarified that the Company shall be entitled to vary the
            abovementioned Charges or introduce new charges, as applicable in
            relation to these services without prior notice at its sole
            discretion
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">6.3.</span>
          <span className="span_section ml1">
            If the User is a corporate employee, then he/she may know the value
            of any other fees and charges from the corporate.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">6.4.</span>
          <span className="span_section ml1">
            Once the Card is loaded, the User cannot transfer money from the
            Card to a bank account.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">6.5.</span>
          <span className="span_section ml1">
            The User shall during the period of these Terms and Conditions bear
            all present and future taxes and other charges levied from time to
            time by any governmental authority pertaining to or in respect of
            the Charges and other amounts paid by the User to the Company under
            these Terms and Conditions and/or any other amounts payable pursuant
            to these Terms and Conditions and pay the same as per the Applicable
            Law. The parties shall bear their own income taxes.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">6.6.</span>
          <span className="span_section ml1">
            The Charges shall be non-refundable, non-transferrable and
            non-assignable in nature. All the Charges, in the absence of
            manifest error, shall be final and binding on the User and be
            conclusive in the nature.
          </span>
        </div>
        <h3 className="mt2">
          VII. <b className="ml1 mt2" style={{marginLeft:"0.3rem"}}>SUBMMISSION OF DETAILS</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">7.1.</span>
          <span className="span_section ml1">
            It shall be your sole responsibility to ensure that any date or
            information, whether electronic otherwise, provided by you to the
            Company at Platform:
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">a.</span>
          <span className="span_section ml1">
            is complete, true and accurate in all respects at all times;
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">b.</span>
          <span className="span_section ml1">
            where applicable, is provided within reasonable time;
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">c.</span>
          <span className="span_section ml1">
            not false, misleading or deceptive in any respect at all times; and
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">d.</span>
          <span className="span_section ml1">
            does not omit anything that affects or is likely to affect the
            meaning or significance of such data, document or other information
            in any respect at all times.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">7.2.</span>
          <span className="span_section ml1">
            The Company hereby disclaim the liability with regard to any failed
            transactions resulting from incorrect, false, or misleading
            information provided by the User. Any losses or inconveniences
            arising from such discrepancies in information shall not be
            attributed to Us. We strongly advise the User to review and verify
            all details before proceeding with any Transaction on our Platform.
          </span>
        </div>
        <h3 className="mt2">
          VIII. <b className="ml1 mt2" style={{marginLeft:"0.3rem"}}>COLLECTION OF INFORMATION</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">8.1.</span>
          <span className="span_section ml1">
            In order to undertake Transaction, the Company will require you to
            provide Us with information relating to you (including personal
            information or sensitive personal data or information as defined
            under the Information Technology (Reasonable Security Practices and
            Procedures and Sensitive Personal Data or Information) Rules, 2011),
            including financial information such as bank account or credit card
            or debit card or other payment instrument details.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">8.2.</span>
          <span className="span_section ml1">
            You may refer to our Privacy Policy which is available at
            <span className="email_style"> prepaid.service@nsdlbank.co.in </span> for details on how the
            Company collects, uses, stores, processes, transfers and protects
            your information or personal data.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">8.3.</span>
          <span className="span_section ml1">
            Initiation of Transaction at Platform by you shall constitute your
            acknowledgement and acceptance of the Privacy Policy and your
            consent to the collection, retention, processing, use,transfer, and
            disclosure of your information (including sensitive personal data or
            information) by the Company in accordance therewith.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">8.4.</span>
          <span className="span_section ml1">
            The Company reserves the right to request for further information
            from you relating to your Account (whether active or in active) at
            any time.
          </span>
        </div>
        <h3 className="mt2">
          IX. <b className="ml1 mt2" style={{marginLeft:"0.7rem"}}>DISCLOSURE OF INFORMATION</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">9.1.</span>
          <span className="span_section ml1">
            The User, hereby agrees and gives consent for the disclosure by the
            Company of all or any information (including sensitive personal data
            or information) relating to the User, as the Company may deem
            appropriate and necessary, to:
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">a.</span>
          <span className="span_section ml1">
            the Company's employees, agents, affiliates, contractors, insurance
            providers or third-party service providers or professional advisers;
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">b.</span>
          <span className="span_section ml1">
            the RBI or any regulatory, supervisory or other authority, court of
            law, tribunal or person, in India or any other jurisdiction, where
            such disclosure is required by law, regulation, judgment or order of
            court or order of any tribunal;
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section ml1">c.</span>
          <span className="span_section ml1">
            any actual or potential assignee(s) or novatee(s) or transferee(s)
            of any rights and obligations of the Company or other participants
            in any of its rights and/or obligations under these presents for any
            purposes connected with the proposed assignment or transfer.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">9.2.</span>
          <span className="span_section ml1">
            The Company, the Issuer and/ or the RBI shall have an unqualified
            right to disclose or publish the name of the User as a willful
            defaulter in such manner and through such medium as the Issuer and/
            or the RBI in its absolute discretion may think fit.
          </span>
        </div>
        <h3 className="mt2"> 
          X. <b className="ml1 mt2">ELECTRONIC COMMUNICATIONS</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">10.1.</span>
          <span className="span_section ml1">
            The User acknowledges that transmission of instruction(s) through
            the Platform, facsimile or through electronic mail (collectively
            <b>“Electronic Communications”</b>) involves a number of risks
            including possibilities of fraudulent alterations and incorrect
            transmissions and absence of confidentiality. However, the User is
            desirous of providing instruction(s) to the Company through
            Electronic Communications and is willing and agreeable to bear all
            associated risks and responsibility of any misuse or unauthorised
            use of such facility
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">10.2.</span>
          <span className="span_section ml1">
            In consideration of the Company permitting the same, the User hereby
            irrevocably agrees to indemnify and hold the Company harmless at all
            times for any loss, damage, claims, costs or expenses (including
            attorney's fee and out of pocket expenses) incurred or suffered by
            the Company as a result of the provision by the User of Electronic
            Communications and/ or the Company having relied upon the same.
          </span>
        </div>
        <h3 className="mt2">
          XI. <b className="ml1 mt2">DISCLAIMERS AND NO WARRANTIES</b>
        </h3>
        <div className="flex-start mt1">
          {/* <span className="span_section">10.2.</span> */}
          <span
            className="span_section ml3"
            style={{ textTransform: "uppercase" }}
          >
            In consideration of the Company permitting the same, the User hereby
            irrevocably agrees to indemnify and hold the Company harmless at all
            times for any loss, damage, claims, costs or expenses (including
            attorney's fee and out of pocket expenses) incurred or suffered by
            the Company as a result of the provision by the User of Electronic
            Communications and/ or the Company having relied upon the same.
          </span>
        </div>
        <h3 className="mt2">
          XII. <b className="ml1 mt2" style={{marginLeft:"0.7rem"}}>BREACH</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">12.1.</span>
          <span className="span_section ml1">
            In the event of any breach of these Terms and conditions by the
            User, we shall have the sole right to forthwith cancel or terminate
            the Transaction without having any liability, claim, demand or
            dispute against Us.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">12.2.</span>
          <span className="span_section ml1">
            The User undertakes and agrees to indemnify Us against any loss,
            damage, claim, penalty, cost, charges or expenses (including legal
            or counsel fees) that we may incur or suffer, whether directly or
            indirectly, as a result of the User committing any breach of the
            Terms and Conditions contained herein.
          </span>
        </div>
        <h3 className="mt2">
          XIII. <b className="ml1 mt2" style={{marginLeft:"0.5rem"}}>LIMITATION OF LIABILITY</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">13.1.</span>
          <span className="span_section ml1">
            In no event will the Company be liable to you for any indirect,
            incidental, special, consequential or punitive damages (including,
            without limitation, damages for loss of profits, goodwill, use,
            data, or other intangible losses) arising out of or relating to your
            access to or use of, or your inability to access or use, the
            Platform /service/Transaction or any materials or content on the
            Platform /service, whether based on warranty, contract, tort
            (including negligence), statute or any other legal theory, whether
            or not the Company have been informed of the possibility of such
            damage.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">13.2.</span>
          <span className="span_section ml1">
            You agree that the aggregate liability of the Company to you for any
            and all claims arising out of relating to the use of or any
            inability to use the Platform / service (including any materials or
            content available through the Platform / service) or otherwise under
            these Terms and Conditions, whether in contract, tort, or otherwise,
            is limited to INR. 100 (Indian Rupees Hundred Only).
          </span>
        </div>
        <h3 className="mt2">
          XIV. <b className="ml1 mt2" style={{marginLeft:"0.5rem"}}>AMENDMENT TO TERM AND CONDITIONS</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">14.1.</span>
          <span className="span_section ml1">
            The Company may, from time to time, amend, restate or supplement the
            Terms and Conditions (including the Charges) at the sole discretion
            of the Company, including to take into account future developments
            such as change in industry trends and/or any changes in legal and/or
            regulatory requirements applicable to the Company.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">14.2.</span>
          <span className="span_section ml1">
            Any amendment, restatement or supplement to the Terms and Conditions
            shall be available at our Platform and, unless stated otherwise,
            shall be effective and binding on you upon publication or at such
            time as may be prescribed by the Company.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">14.3.</span>
          <span className="span_section ml1">
            You agree that the publication of any amendment, restatement or
            supplement to the Terms and Conditions through the Platform shall be
            sufficient notice to you and that your continued access and/or use
            of Platform shall constitute your acceptance of such amendment,
            restatement or supplement to the Terms and Conditions.
          </span>
        </div>
        <h3 className="mt2">
          XV. <b className="ml1 mt2" style={{marginLeft:"0.5rem"}}>USER GRIEVANCE REDRESSAL</b>
        </h3>
        <div className="flex-start mt1">
          <span className="span_section">15.1.</span>
          <span className="span_section ml1">
            In the event of any dispute or grievance in relation to the
            Transaction and/or these Terms and Conditions, the User may contact
            the customer care center at [<span className="email_style"> nodalofficer@nsdlbank.co.in </span>] and
            <b>[022-42022190]</b>.
          </span>
        </div>
        <div className="flex-start mt1">
          <span className="span_section">15.2.</span>
          <span className="span_section ml1">
            We will ensure that all complaints, disputes or grievance raised by
            the User shall be addressed and/or resolved in a time bound manner.
          </span>
        </div>
      </div>
    ),
  },
];

const TermsandCondition = () => {
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <div className="infoPolicy_section">
      <Tabs
        defaultActiveKey="1"
        tabPosition={"top"}
        onChange={onChange}
        style={{ height: "650px", overflow: "auto" }}
      >
        {items.map((ele) => (
          <Tabs.TabPane tab={ele.label} key={ele.key}>
            {ele.children}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  );
};
export default TermsandCondition;
